import { render } from "./TableauWarehouseGrid.vue?vue&type=template&id=378754df&ts=true"
import script from "./TableauWarehouseGrid.vue?vue&type=script&lang=ts"
export * from "./TableauWarehouseGrid.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__